import Component from '../site/Component';

/**
 * Component for formatting Featured Video from YouTube and Facebook.
 */
export default class VideoFormat extends Component {

  /**
   * Start the component (called when Component is instantiated)
   */
  /* eslint-disable class-methods-use-this */
  start() {
    const featured = document.querySelector(this.elements.featured);

    if (featured) {
      window.onload = this.formatFBVideos();
    }
  }

  formatFBVideos() {
    const videos = document.querySelectorAll(this.elements.video);
    if (videos) {
      Array.prototype.forEach.call(
        videos,
        (video) => {
          const videoContainer = video.childNodes[3];
          if (videoContainer) {
            if (videoContainer.classList.contains('fb-video')) {
              video.classList.add('facebook-video-embed');
            }
          }
        }
      );
    }
  }
}
